export default __webpack_public_path__ + "static/media/default-avatar.d2ff7ec9.png";